module.exports = __webpack_public_path__ + "img/yizhuxiao.3c160e00.png";